import React from 'react';
import { Container } from 'reactstrap';
import classNames from 'classnames';
import NeedHelp from '../../modals/NeedHelp/NeedHelp';
import styles from './SibiFooter.module.css';

const SibiFooter = () => {
    return (
        <>
            <Container className={styles.footerText}>
                <div>
                    <p>
                        Protection plans are issued by AIG WarrantyGuard, Inc., part of AIG, or one or more of its
                        affiliates. Plans are subject to detailed terms, conditions and limitations. For further
                        information, please review the full plans
                        <a
                            href='/coveragedocs'
                            target='blank'
                            className='ml-1'
                        >
                            terms and conditions
                        </a>
                        .
                    </p>
                    <p>All trademarks are owned by their respective companies.</p>
                </div>
            </Container>
            <footer className={styles.sibiFooter}>
                <Container className={styles.footerPadding}>
                    <ul className={styles.navItem}>
                        <li>
                            <a
                                href='https://www.aig.com/privacy-policy'
                                target='_blank'
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/terms-of-use'
                                target='_blank'
                            >
                                Terms of Use
                            </a>
                        </li>
                    </ul>
                    <p>
                        Copyright &#169; {new Date().getFullYear()}, American International Group, Inc. All rights
                        reserved.
                    </p>
                </Container>
                <NeedHelp />
            </footer>
        </>
    );
};

export default SibiFooter;
